import MealGuideCategory from '@/models/MealGuideCategory'
import { map, isNumber } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    filter: {
      search: null,
    },
    selectedData: {},
  },

  mutations: {
    setDataList(state, results) {
      state.list = map(results, (row) => {
        if (row instanceof MealGuideCategory) {
          return row
        } else {
          return new MealGuideCategory(row)
        }
      })
    },

    clearList(state) {
      state.list = []
    },

    setSelectedData(state, data) {
      if (data instanceof MealGuideCategory) {
        state.selectedData = data
      } else {
        state.selectedData = new MealGuideCategory(data)
      }
    },

    setFilter(state, filter) {
      state.filter = filter
    },
  },

  actions: {
    async getDataList({ commit }, params) {
      const { search } = params

      const query = MealGuideCategory

      // eslint-disable-next-line eqeqeq
      if (search != undefined) {
        if (isNumber(search)) {
          query.where('id', search)
        } else {
          query.where('search', search)
        }
      }

      const { data } = await query.get()

      commit('setDataList', data)
    },

    async getSingleData({ commit }, id) {
      let content = await MealGuideCategory.find(id)

      commit('setSelectedData', content.data)

      return content
    },

    async saveData({ commit }, params) {
      let { data } = await new MealGuideCategory(params).save()

      commit('setSelectedData', data)

      return data
    },
  },
}
